import { render, staticRenderFns } from "./BtnConclusaoEtapa.vue?vue&type=template&id=36de86d4&"
import script from "./BtnConclusaoEtapa.vue?vue&type=script&lang=js&"
export * from "./BtnConclusaoEtapa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports